// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3LK7C","col":"styles_col__1EgUE"};